{
  "title": "Rime's Binding Ice",
  "source": "Fizban's Treasury of Dragons",
  "levelAndSchool": "2nd-level Evocation",
  "level": 2,
  "castingTime": "1 Action",
  "range": "Self (30-foot cone)",
  "components": "S, M (a vial of meltwater)",
  "duration": "Instantaneous",
  "description": [
    "A burst of cold energy emanates from you in a 30-foot cone. Each creature in that area must make a Constitution saving throw. On a failed save, a creature takes 3d8 cold damage and is hindered by ice formations for 1 minute, or until it or another creature within reach of it uses an action to break away the ice. A creature hindered by ice has its speed reduced to 0. On a successful save, a creature takes half as much damage and isn’t hindered by ice.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, increase the cold damage by 1d8 for each slot level above 2nd."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "wizard"]
}
